import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
/** Classic anon JWT or newer publishable key — either works as the client API key. */
const anonKey =
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ||
  (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined);

const isPlaceholderKey = (key: string) =>
  key.includes("YOUR_SUPABASE_ANON_KEY") ||
  key.includes("YOUR_PUBLISHABLE") ||
  key.includes("YOUR_PROJECT");

export const isSupabaseConfigured = Boolean(
  url && anonKey && !url.includes("YOUR_PROJECT_REF") && !isPlaceholderKey(anonKey)
);

export const siteUrl =
  (import.meta.env.VITE_SITE_URL as string | undefined)?.replace(/\/$/, "") ||
  (typeof window !== "undefined" ? window.location.origin : "");

/** Null when env is missing — UI must show setup guidance, never invent credentials. */
export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(url!, anonKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: typeof window !== "undefined" ? window.localStorage : undefined,
      },
    })
  : null;
